import { render, staticRenderFns } from "./commodityStickerOperation.vue?vue&type=template&id=355abc01&scoped=true"
import script from "./commodityStickerOperation.vue?vue&type=script&lang=js"
export * from "./commodityStickerOperation.vue?vue&type=script&lang=js"
import style0 from "./commodityStickerOperation.vue?vue&type=style&index=0&id=355abc01&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355abc01",
  null
  
)

export default component.exports